module.exports = __webpack_public_path__ + "img/icon_allgoodf_selfshop_pre.530cd735.png";